import {getElementFromLocalStorage} from 'app/helpers/webStorageUtility';

const initialData = {
  disableAds: false,
  disableVideoAds: false,
};

const DevToolsReducer = (state = initialData, action) => {
  switch (action.type) {
    case 'UPDATE_DISABLE_ADS':
      return {...state, disableAds: action.data};
    case 'UPDATE_DISABLE_VIDEO_ADS':
      return {...state, disableVideoAds: action.data};
    default:
      return state;
  }
};

// will be used to pre-populate preloadedState in store.js
// We need to create a copy, otherwise initialData would act as global variable and would share session across different users
// Reason: redux-cookies-middleware.getStateFromCookies() does not copy data in preloadedState, it just extends it (which creates global variable/state)
const createInitialDeveloperData = () => {
  // Need to do deep copy of initial state to avoid sharing nested object values to different requests
  const copyInitialState = JSON.parse(JSON.stringify(initialData));
  let state = {...copyInitialState};
  const defaultDisableAds = process.env.ENVIRONMENT !== 'prod';

  const disableAdsStorage = getElementFromLocalStorage('disableAds');
  const disableVideoAdsStorage = getElementFromLocalStorage('disableVideoAds');

  const disableAds = disableAdsStorage ? JSON.parse(disableAdsStorage) : defaultDisableAds;
  const disableVideoAds = disableVideoAdsStorage ? JSON.parse(disableVideoAdsStorage) : false;

  state = {...state, disableAds, disableVideoAds};

  return state;
};

export {DevToolsReducer, createInitialDeveloperData};
